module.exports = __webpack_public_path__ + "static/img/illustratepic_01.cd0a1a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh-CN/illustratepic_01.png
// module id = Bz9/
// module chunks = 1